'use client';

import 'swiper/css';
import 'swiper/css/pagination';

import { Box } from '@chakra-ui/react';
import Image from 'next/image';
import React from 'react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

interface BannerType {
  desktop: string;
  mobile: string;
  link: string;
  index: string;
}

export default function BannerSwiper({
  banners,
}: {
  banners: Array<BannerType>;
  aspectRatio?: string;
}) {
  return (
    <Box w="100%" borderRadius="md" overflow="hidden" height="100%">
      <Swiper
        modules={ [ Autoplay, Pagination ] }
        slidesPerView={ 1 }
        loop={ banners.length > 1 }
        className="hero-banner-swiper"
        autoplay={
          banners.length > 1 ?
            { delay: 3000, disableOnInteraction: false } :
            false
        }
        pagination={{ clickable: true }}
        style={{ width: '100%', height: '100%' }}
      >
        { banners.map((banner) => (
          <SwiperSlide key={ banner.index }>
            <Box
              position="relative"
              w="100%"
              aspectRatio="800/152"
              borderRadius="8px"
              height="100%"
              overflow="hidden"
              cursor="pointer"
              onClick={ () =>
                window.open(banner.link, '_blank', 'noopener,noreferrer')
              }
            >
              <Image
                src={ banner.desktop }
                alt="ads banner"
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                style={{ objectFit: 'cover' }}
                className="block-on-desktop"
              />
              <Image
                src={ banner.mobile }
                alt="ads banner"
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                style={{ objectFit: 'cover' }}
                className="block-on-mobile"
              />
            </Box>
          </SwiperSlide>
        )) }
      </Swiper>
    </Box>
  );
}
